import React, { useState } from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

// Same rule as Offer Letters: Basic 60% / Housing 25% / Transportation 10% / Other = remainder (~5%)
export const splitTotal = (value) => {
  const total = Math.round(parseFloat(String(value).replace(/[^0-9.]/g, '') || '0')) || 0;
  if (total <= 0) return null;
  const basic = Math.round(total * 0.60);
  const housing = Math.round(total * 0.25);
  const transportation = Math.round(total * 0.10);
  return { basic, housing, transportation, other: total - basic - housing - transportation };
};

export const SalarySplitInput = ({ onSplit, testId = 'salary-split-total' }) => {
  const [total, setTotal] = useState('');
  return (
    <div className="rounded-md border border-dashed border-violet-300 bg-violet-50/50 p-2.5 mb-3">
      <Label className="text-xs">Total wage (optional) — auto-split</Label>
      <Input type="number" min="0" placeholder="e.g. 4700" value={total} className="mt-1 max-w-[200px]"
        onChange={e => { setTotal(e.target.value); const s = splitTotal(e.target.value); if (s) onSplit(s); }}
        data-testid={testId} />
      <p className="text-[11px] text-gray-500 mt-1">Basic 60% · Housing 25% · Transportation 10% · Others 5% (rounded). You can still edit each box.</p>
    </div>
  );
};
